import { useState } from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import * as Sentry from '@sentry/react';
import { Dialog } from '@mui/material';
import { IconX, IconAlertCircleFilled } from '@tabler/icons-react';

import { Button, IconButton, Input } from 'ui';

const nameValidation = yup.string().required('Name is required.').min(2, 'Name must be at least 2 characters.');

const DesignationModal = ({ open, onClose, initialName = '', initialCode = '', onSave, title = 'New Designation' }) => {
  const [name, setName] = useState(initialName);
  const [code, setCode] = useState(initialCode);
  const [error, setError] = useState('');

  const handleClose = () => {
    onClose();
    setName('');
    setCode('');
    setError('');
  };

  const handleSave = () => {
    try {
      setError('');
      nameValidation.validateSync(name);
      onSave({ name, code });
      handleClose();
    } catch (err) {
      Sentry.captureException(err);
      setError(err.message);
    }
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      sx={{ '.MuiPaper-root': { padding: 0, margin: 0, borderRadius: '12px', width: '100%' } }}
      closeAfterTransition={false}
    >
      <div className="space-y-6 p-6">
        <div className="relative flex">
          <div className="flex items-center space-x-3">
            <IconAlertCircleFilled size={20} className="text-primary-700" />
            <h3 className="text-h6 font-semibold">{title}</h3>
          </div>

          <IconButton
            Icon={<IconX size={20} className="text-gray-400" />}
            srOnly="Close"
            onClick={handleClose}
            color="transparent"
            className="absolute -right-1 -top-1 !p-1"
          />
        </div>

        <div className="space-y-6">
          <Input
            id="designation-name"
            label="Designation Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Building Fund"
            required
            error={!!error}
            helperText={error}
            size="xl"
            containerClassName="w-full"
          />

          <Input
            id="designation-code"
            label="Code (optional)"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="BLDG-001"
            size="xl"
            containerClassName="w-full"
            helperText="Not visible to donors. May be used for accounting or reporting"
          />
        </div>

        <div className="flex justify-end space-x-3">
          <Button title="Cancel" onClick={handleClose} />
          <Button title="Save" color="primary" onClick={handleSave} />
        </div>
      </div>
    </Dialog>
  );
};

DesignationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  initialName: PropTypes.string,
  initialCode: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default DesignationModal;
